module.exports = __webpack_public_path__ + "static/media/logos-print-orientation.2610ec6f.jpg";